import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  type ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { errorInterceptor } from '@core/interceptors/error.interceptor';
import { routes } from './app.routes';
import { officeInterceptor } from './core/interceptors/office.interceptor';
import { authInterceptor } from './core/interceptors/token.interceptor';
import { materialProviders } from './core/overrides/material-config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withInterceptors([authInterceptor, officeInterceptor, errorInterceptor]),
    ),
    provideRouter(routes, withComponentInputBinding()),
    ...materialProviders,
  ],
};
